import React from 'react';
import Card from '../Card/Card';
import Pagination from '../Pagination/Pagination';

export default function SearchResultFooter({
  query,
  total,
  itemsPerPage,
  currentPage,
  maxPages,
}) {
  if (!total) return null;
  const track = { context: 'Search', value: { origin: 'Footer' } };

  return (
    <Card className="text-center">
      <Pagination
        track={track}
        query={query}
        total={total}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        maxPages={maxPages}
      />
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/SearchResults/SearchResultFooter.js